import React, { useEffect, useRef, useState } from "react";
import {
  RiMarkPenLine,
  RiDeleteBinLine,
  RiMoreFill,
  RiUserUnfollowLine,
  RiStopLine,
  RiCheckLine,
} from "react-icons/ri";

enum ActionType {
  UserDetails = "USER_DETAILS",
  Edit = "EDIT",
  Suspend = "SUSPEND",
  Activate = "ACTIVATE",
  Block = "BLOCK",
  Delete = "DELETE",
}

interface ActionDropdownProps {
  user: any;
  onAction: (action: ActionType, userId: string) => void;
}

const ActionDropdown: React.FC<ActionDropdownProps> = ({ user, onAction }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);

  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        triggerRef.current &&
        !triggerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [isOpen]);

  const actionItems = [
    {
      label: "View Details",
      icon: <RiMarkPenLine className="mr-2 text-[#0eb683]" />,
      action: ActionType.UserDetails,
      className: "text-[#0eb683]",
    },
    {
      label: user.profileStatus === "suspended" ? "Activate" : "Suspend",
      icon:
        user.profileStatus === "suspended" ? (
          <RiCheckLine className="mr-2 text-[#0eb683]" />
        ) : (
          <RiStopLine className="mr-2 text-orange-500" />
        ),
      action:
        user.profileStatus === "suspended"
          ? ActionType.Activate
          : ActionType.Suspend,
      className:
        user.profileStatus === "suspended"
          ? "text-green-600"
          : "text-orange-600",
    },
    {
      label: "Block",
      icon: <RiUserUnfollowLine className="mr-2 text-yellow-500" />,
      action: ActionType.Block,
      className: "text-yellow-600",
    },
    {
      label: "Delete",
      icon: <RiDeleteBinLine className="mr-2 text-red-500" />,
      action: ActionType.Delete,
      className: "text-red-600",
    },
  ];

  return (
    <div className="relative">
      <button
        ref={triggerRef}
        onClick={() => setIsOpen(!isOpen)}
        className="hover:bg-gray-200 rounded-full p-1 transition-all"
      >
        <RiMoreFill className="h-5 w-5 text-gray-600" />
      </button>

      {isOpen && (
        <div
          ref={dropdownRef}
          className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
        >
          <div className="py-1">
            {actionItems.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  onAction(item.action, user);
                  setIsOpen(false);
                }}
                className={`flex items-center w-full px-4 py-2 text-sm ${
                  item.className || "text-gray-700"
                } hover:bg-gray-100`}
              >
                {item.icon}
                {item.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
